export const AUTH_DEVICE_READY = 'AUTH_DEVICE_READY';
export const AUTH_USER_LOGIN = 'AUTH_USER_LOGIN';
export const AUTH_DATA_LOADING = 'AUTH_DATA_LOADING';
export const STUDENT_DASHBOARD_LOADED = 'STUDENT_DASHBOARD_LOADED';
export const STUDENT_CURRICULUM_LOADED = 'STUDENT_CURRICULUM_LOADED';
export const STUDENT_CURRICULUM_CLEARED = 'STUDENT_CURRICULUM_CLEARED';
